(function () {
  'use strict';
  if (window.EroLoox) return;

  // Loox Storefront API (Loox Convert plan). The public store id is safe in
  // theme code; no secret key is used anywhere. Reviews are keyed to LIVE
  // Shopify product ids, which is why the dev store maps them through the
  // custom.loox_product_id product metafield.
  var BASE = 'https://storefront-api.loox.io/storefront/v1/store/OZLHx-07cI.6ee380d9b7c58522d61f28218065d901fecb349e01d2e0434b8a6ba177012e47';
  var TIMEOUT_MS = 5000;
  var cache = new Map();

  // One request per path per page load. Failures resolve to null and are
  // dropped from the cache so a later call can retry.
  function getJSON(path) {
    if (cache.has(path)) return cache.get(path);
    var controller = new AbortController();
    var timer = window.setTimeout(function () { controller.abort(); }, TIMEOUT_MS);
    var request = fetch(BASE + path, { mode: 'cors', credentials: 'omit', signal: controller.signal })
      .then(function (response) { return response.ok ? response.json() : null; })
      .catch(function () { return null; })
      .then(function (data) {
        window.clearTimeout(timer);
        if (data === null) cache.delete(path);
        return data;
      });
    cache.set(path, request);
    return request;
  }

  // Rating from ratingDistribution with integer math, rounded to one decimal.
  // Every bottomline must succeed and the total must be above zero, otherwise
  // null (a product with no reviews returns 0, never 404).
  function summarize(list) {
    var total = 0;
    var stars = 0;
    for (var i = 0; i < list.length; i += 1) {
      var bottomline = list[i];
      if (!bottomline || !bottomline.ratingDistribution) return null;
      for (var s = 1; s <= 5; s += 1) {
        var count = Number(bottomline.ratingDistribution[String(s)]) || 0;
        total += count;
        stars += count * s;
      }
    }
    if (total === 0) return null;
    return { total: total, rating: Math.round((stars * 10) / total) / 10 };
  }

  // Per-star counts summed across every bottomline, plus the same total and
  // rating as summarize. Same validation: any missing bottomline or a zero
  // total resolves to null.
  function distributionOf(list) {
    var total = 0;
    var stars = 0;
    var distribution = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    for (var i = 0; i < list.length; i += 1) {
      var bottomline = list[i];
      if (!bottomline || !bottomline.ratingDistribution) return null;
      for (var s = 1; s <= 5; s += 1) {
        var count = Number(bottomline.ratingDistribution[String(s)]) || 0;
        distribution[s] += count;
        total += count;
        stars += count * s;
      }
    }
    if (total === 0) return null;
    return {
      total: total,
      rating: Math.round((stars * 10) / total) / 10,
      distribution: distribution
    };
  }

  // CLAUDE.md copy rule: these two Loox reviewers are family and are never
  // featured or quoted on the site. Filtered here, in the shared client, so
  // every review surface inherits it. Matched on the reviewer name Loox
  // sends, trimmed and lowercased. Ratings are untouched: they come from
  // Loox's own counts, not from these lists.
  var EXCLUDED_REVIEWERS = ['kathleen n.', 'nicole l.'];

  function isExcluded(review) {
    var name = review && review.reviewer && review.reviewer.name;
    return EXCLUDED_REVIEWERS.indexOf(String(name || '').trim().toLowerCase()) !== -1;
  }

  // The reviews array from a list response, excluded reviewers dropped, or
  // null when the call failed. Every review-list method resolves through
  // this, so no caller can receive an excluded review.
  function reviewsOf(data) {
    if (!data || !Array.isArray(data.reviews)) return null;
    return data.reviews.filter(function (review) { return !isExcluded(review); });
  }

  function productBottomline(id) {
    return getJSON('/product-reviews/bottomline/' + encodeURIComponent(id));
  }

  function storeBottomline() {
    return getJSON('/store-reviews/bottomline');
  }

  window.EroLoox = {
    productRating: function (id) {
      if (!id) return Promise.resolve(null);
      return productBottomline(id).then(function (data) { return summarize([data]); });
    },
    allProductsRating: function () {
      return getJSON('/product-reviews/bottomline').then(function (data) { return summarize([data]); });
    },
    combinedRating: function (ids) {
      var list = (ids || []).filter(Boolean);
      if (!list.length) return Promise.resolve(null);
      return Promise.all(list.map(productBottomline)).then(summarize);
    },
    // Per-star counts for the Reviews page summary. scope: 'all' = every
    // product plus the store reviews, 'store' = store reviews only, any other
    // value = one LIVE Shopify product id. Counts come from Loox's own
    // bottomlines, so they include every reviewer; the reviewer exclusion
    // applies to review lists only, the same as the ratings.
    bottomline: function (scope) {
      if (!scope) return Promise.resolve(null);
      if (scope === 'all') {
        return Promise.all([getJSON('/product-reviews/bottomline'), storeBottomline()]).then(distributionOf);
      }
      if (scope === 'store') {
        return storeBottomline().then(function (d) { return distributionOf([d]); });
      }
      return productBottomline(scope).then(function (d) { return distributionOf([d]); });
    },
    productReviews: function (id, options) {
      if (!id) return Promise.resolve(null);
      var o = options || {};
      var query = '?product_id=' + encodeURIComponent(id) + '&limit=' + (o.limit || 100);
      if (o.rating) query += '&rating=' + encodeURIComponent(o.rating);
      if (o.sort) query += '&sort=' + encodeURIComponent(o.sort);
      return getJSON('/product-reviews' + query).then(reviewsOf);
    },
    // Every product's reviews in one list: /product-reviews with NO
    // product_id returns the whole catalogue (57 on Sep 28, 2026).
    allProductReviews: function (options) {
      var o = options || {};
      var query = '?limit=' + (o.limit || 100);
      if (o.sort) query += '&sort=' + encodeURIComponent(o.sort);
      return getJSON('/product-reviews' + query).then(reviewsOf);
    },
    // Store reviews (about ERO, not a product). No verified field.
    storeReviews: function (options) {
      var o = options || {};
      var query = '?limit=' + (o.limit || 100);
      if (o.sort) query += '&sort=' + encodeURIComponent(o.sort);
      return getJSON('/store-reviews' + query).then(reviewsOf);
    },
    // One id = that product's rating; two or more = combined and rounded.
    ratingFor: function (ids) {
      var list = (ids || []).filter(Boolean);
      if (!list.length) return Promise.resolve(null);
      return list.length === 1
        ? window.EroLoox.productRating(list[0])
        : window.EroLoox.combinedRating(list);
    },
    formatRating: function (value) {
      return Number(value).toFixed(1);
    }
  };
})();
